if (!customElements.get('compatible-bulbs')) {
	class CompatibleBulbs extends HTMLElement {
		connectedCallback() {
			const url = this.dataset.url;
			const limit = Number.parseInt(this.dataset.limit, 10) || 3;
			const max = Number.parseInt(this.dataset.max, 10) || limit;
			const list = this.querySelector('.compatible-bulbs__list');
			if (!url || !list) return;

			fetch(url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const seen = new Set();
					const rows = [];

					html.querySelectorAll('.compatible-bulbs__item').forEach((item) => {
						const handle = item.dataset.product;
						if (rows.length >= max) return;
						if (!handle || handle === this.dataset.productHandle || seen.has(handle)) return;
						seen.add(handle);
						rows.push(item);
					});

					if (rows.length === 0) return;

					const quantity = Number.parseInt(this.dataset.quantity, 10) || 1;
					rows.forEach((item, index) => {
						if (index >= limit) item.hidden = true;
						const input = item.querySelector('.quantity__input');
						if (input) input.value = quantity;
						list.appendChild(item);
					});

					this.setupMore(rows.length - limit);
					this.hidden = false;
				})
				.catch(() => {
					this.hidden = true;
				});
		}

		setupMore(extra) {
			const button = this.querySelector('.compatible-bulbs__more');
			if (!button || extra <= 0) return;

			const template = extra === 1 ? this.dataset.moreOne : this.dataset.moreOther;
			const label = button.querySelector('.button-label') || button;
			label.textContent = (template || '').replace('[count]', extra);
			button.hidden = false;
			button.addEventListener('click', () => {
				this.querySelectorAll('.compatible-bulbs__item[hidden]').forEach((item) => {
					item.hidden = false;
				});
				button.hidden = true;
			});
		}
	}

	customElements.define('compatible-bulbs', CompatibleBulbs);
}
